<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'SummaryUsageList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              SummaryUsage
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">SummaryUsage</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="SummaryUsage">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-row">
                    <div class="col-md-6 form-group">
                      <label class="control-label">User ID</label>
                      <input
                        type="text"
                        id="userid"
                        name="userid"
                        v-model="value.userid"
                        class="form-control userid"
                        placeholder="User ID"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Router MAC</label>
                      <input
                        type="text"
                        id="ap_wi_mac"
                        name="ap_wi_mac"
                        v-model="value.ap_wi_mac"
                        class="form-control ap_wi_mac"
                        placeholder="Router MAC"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Device MAC</label>
                      <input
                        type="text"
                        id="device_mac"
                        name="device_mac"
                        v-model="value.device_mac"
                        class="form-control device_mac"
                        placeholder="Device MAC"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Acttype</label>
                      <input
                        type="text"
                        id="acttype"
                        name="acttype"
                        v-model="value.acttype"
                        class="form-control acttype"
                        placeholder="Acttype"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Total Usages</label>
                      <input
                        type="text"
                        id="total_usages"
                        name="total_usages"
                        v-model="value.total_usages"
                        class="form-control total_usages"
                        placeholder="Total Usages"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Download</label>
                      <input
                        type="text"
                        id="download"
                        name="download"
                        v-model="value.download"
                        class="form-control download"
                        placeholder="Download"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Upload</label>
                      <input
                        type="text"
                        id="upload"
                        name="upload"
                        v-model="value.upload"
                        class="form-control upload"
                        placeholder="Upload"
                      />
                    </div>
                    <div class="col-md-6 form-group required">
                      <label class="control-label">Attempted</label>
                      <input
                        type="text"
                        id="attempted"
                        name="attempted"
                        v-bind:class="{ 'has-error': errors.has('attempted') }"
                        v-validate="'required'"
                        v-model="value.attempted"
                        class="form-control attempted"
                        placeholder="Attempted"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('attempted')"
                      >
                        {{ errors.first("attempted") }}
                      </div>
                    </div>
                    <div class="col-md-12 form-group">
                      <label class="control-label">Usages Date</label>
                      <div class="clearfix"></div>
                      <el-date-picker
                        v-model="value.usages_date"
                        type="date"
                        placeholder="Select date"
                        id="usages_date"
                        name="usages_date"
                        class="d-block usages_date w-100"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pb-4 pt-0">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "SummaryUsageForm",
  metaInfo: {
    title: "SummaryUsage | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {},
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/summaryusages";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/summaryusages/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "SummaryUsageList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/summaryusages/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log('error ' + error)
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((error) => {
            console.log(error.response);
          });
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
